import ModalChangeDevice from "./ModalChangeDevice";

export default ModalChangeDevice;
